<div class="min-vh-100">
  <div class="d-flex flex-column gap-4 gap-lg-3 mx-auto">
    <section class="entity-config-top mb-1 rounded-4 overflow-hidden shadow-sm">
      <div class="entity-config-top-hero px-2 px-md-3 py-3">
        <div class="row g-2 align-items-start flex-nowrap">
           <div class="col">
            <h1 class="entity-page-title text-white fw-bold lh-sm mb-1">Form Management Hub</h1>
            <p class="entity-page-subtitle text-white mb-0">
             Manage your data collection logic through our form builder.
            </p>
          </div>

          <div class="col-auto d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-primary-dark text-xs shadow-lg d-inline-flex align-items-center"
              data-bs-toggle="modal"
              data-bs-target="#create_form"
              @click="open_create_form_modal"
            >
              <span>+ Create New Form</span>
            </button>
          </div>
        </div>
      </div>
      <section class="entity-config-top rounded-4 overflow-hidden border-0">
      <div class="px-2 px-md-2 pb-2 mt-3 mb-2">
        <div class="d-inline-flex card-header-primary rounded p-1 gap-1 align-self-start p-2 mt-1">
          <button
            type="button"
            class="btn rounded-3 px-4 py-2 shadow-sm text-xs"
            :class="active_tab === 'forms' ? 'btn-primary-dark text-white' : 'text-white border-0'"
            @click="set_active_tab('forms')"
          >
            Active Forms
          </button>
          <button
            type="button"
            class="btn rounded-3 px-4 py-2 shadow-sm text-xs"
            :class="active_tab === 'archive' ? 'btn-primary-dark text-white' : 'text-white border-0'"
            @click="set_active_tab('archive')"
          >
            Archive & History
          </button>
        </div>
      </div>
    </section>
    </section>
    <section class="d-flex flex-column gap-4">

      <section v-if="active_tab === 'forms'">        
        <div class="row g-3 g-xl-4 pt-1">
          <div v-if="active_forms_loading" class="col-12">
            <div class="card border-0 shadow-sm rounded-4">
              <div class="card-body p-4 text-secondary text-xs">
                Loading forms...
              </div>
            </div>
          </div>

          <div v-else-if="!all_forms.length" class="col-12">
            <div class="card border-0 shadow-sm rounded-4">
              <div class="card-body p-4 text-secondary text-xs">
                No forms found.
              </div>
            </div>
          </div>

          <div
            v-for="form in all_forms"
            :key="form.id"
            class="col-12 col-md-6 col-xl-4"
          >
            <article class="card h-100 border-purple border-opacity-50 shadow rounded-4">
              <div class="card-body p-4 d-flex flex-column h-100">
                <div class="d-flex justify-content-between align-items-start mb-4">
                  <div
                    class="entity-type-icon entity-icon-surface rounded-3 d-inline-flex align-items-center justify-content-center"
                    :class="form.icon_wrapper_class"
                  >
                    <i :class="form.icon"></i>
                  </div>
                  <span
                    class="badge rounded-pill text-uppercase fw-bold px-2 py-1 text-xxs lh-1"
                    :class="form.status_badge_class"
                  >
                    {{ form.status }}
                  </span>
                </div>

                <p class="text-x text-dark mb-2">{{ form.title }}</p>
                <p class="text-secondary text-xs lh-base mb-2 flex-grow-1">{{ form.description }}</p>

                <div class="border-top pt-3 mt-auto">
                  <div class="d-flex justify-content-between align-items-end gap-3">
                    <div>
                      <div class="text-uppercase fw-bold text-secondary mb-1 text-xxs">
                        Last Edited
                      </div>
                      <div class="text-xs fw-semibold text-dark text-nowrap">{{ form.last_edited }}</div>
                    </div>

                    <router-link
                      :to="{ name: 'CreateSections', query: { form_id: form.id, form_name: form.title } }"
                      class="text-xs fw-bold d-inline-flex align-items-center gap-1"
                    >
                      <span>Form Builder</span>
                      <i class="bi bi-arrow-right fs-6"></i>
                    </router-link>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>

      <section v-else class="card border rounded-4 shadow-sm">
        <div class="card-body p-3 p-md-4">
          <div class="d-flex flex-column flex-lg-row justify-content-between align-items-start gap-3 pb-3">
            <div>
              <p class="text-x fw-bold mb-1">Archived Forms</p>
              <p class=" text-x text-secondary mb-0">
                Reference or restore previously deprecated logic streams.
              </p>
            </div>

            <button
              type="button"
              class="btn btn-light border rounded-3 d-inline-flex align-items-center gap-2 px-3 py-2 text-dark text-xs"
            >
              <i class="bi bi-clock-history"></i>
              <span>Global Log</span>
            </button>
          </div>

          <div class="pt-2">
            <div
              v-if="!archived_history_forms.length"
              class="py-4 text-secondary text-xs"
            >
              No archived forms found.
            </div>

            <div
              v-for="item in archived_history_forms"
              :key="item.id"
              class="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center gap-3 py-4 px-2 border-top"
            >
              <div class="d-flex align-items-start gap-3">
                <div
                  class="entity-type-icon entity-icon-surface rounded-3 d-inline-flex align-items-center justify-content-center flex-shrink-0"
                  :class="item.icon_wrapper_class"
                >
                  <i :class="item.icon"></i>
                </div>

                <div>
                  <p class="text-xs fw-bold mb-1">{{ item.title }}</p>
                  <div class="text-uppercase text-secondary text-xs text-nowrap">
                    {{ item.form_type_label }}
                    <span class="mx-2">&bull;</span>
                    {{ item.last_edited }}
                  </div>
                </div>
              </div>

              <div class="d-flex justify-content-end align-items-center gap-1 w-100 w-lg-auto ms-lg-auto">
                <router-link
                  :to="{ name: 'PreviewForm', query: { form_id: item.id, form_name: item.title } }"
                  class="btn btn-primary-dark flex-fill flex-lg-grow-0 text-xxs rounded-2"
                >
                  View Form
                </router-link>
                <button type="button" class="btn btn-primary-dark flex-fill flex-lg-grow-0 text-xxs ">
                  Restore
                </button>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-center align-items-center gap-2 pt-3 text-dark text-xs">
            <span>Load more archived records</span>
            <i class="bi bi-chevron-down small"></i>
          </div>
        </div>
      </section>
    </section>
  </div>

  <teleport to="body">
    <div class="modal fade" id="create_form" tabindex="-1" aria-labelledby="create_form_label" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <p class="modal-title text-white text-xs mb-0" id="create_form_label">Create Form</p>
            <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body">
            <div class="modal-form-group form-group mb-3">
              <label for="form_name" class="modal-form-label form-label text-xs">Form Name:</label>
              <input
                type="text"
                id="form_name"
                v-model="form_name"
                class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
                placeholder="Please enter a name for the form"
                aria-labelledby="form_name"
              />
              <small
                id="form_name_error"
                class="text-danger p-2 text-xs fw-bold d-none project-name-messages"
              >
                Please enter a name for the form
              </small>
              <small
                id="form_name_generic_error"
                class="text-danger p-2 text-xs fw-bold d-none error-messages"
              ></small>
            </div>

            <div class="modal-form-group form-group mb-3">
              <label for="name_description" class="modal-form-label form-label text-xs">Form Description
                (Optional):</label>
              <input
                type="text"
                id="name_description"
                v-model="form_description"
                class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
                placeholder="Please enter a description for the form"
                aria-labelledby="name_description"
              />
              <small
                id="name_description_error"
                class="text-danger p-2 text-xs fw-bold d-none project-description-messages"
              >
                Please enter a description for the form
              </small>
              <small
                id="name_description_generic_error"
                class="text-danger p-2 text-xs fw-bold d-none error-messages"
              ></small>
            </div>

            <div class="modal-form-group form-group mb-3">
              <label class="modal-form-label form-label text-xs">Form Type:</label>
              <div class="position-relative">
                <select
                  class="modal-form-control form-control text-xs pe-5"
                  v-model="form_type_id"
                  :disabled="form_types_loading"
                >
                  <option disabled value="" hidden>
                    {{ form_types_loading ? 'Loading Form Types...' : 'Select Form Type' }}
                  </option>
                  <option v-for="type in form_types" :key="type.id" :value="type.id">
                    {{ type.form_type }}
                  </option>
                </select>
                <i class="bi bi-chevron-down position-absolute top-50 end-0 translate-middle-y me-3 text-secondary cursor-pointer dropdown-arrow"></i>
              </div>
            </div>

            <small v-if="modal_error_message" class="text-danger p-2 text-xs fw-bold d-block">
              {{ modal_error_message }}
            </small>
          </div>

          <div class="modal-footer border-0 p-2 d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-primary-dark btn-sm rounded-small text-xs shadow text-dark"
              @click="create_form"
              :disabled="create_form_running"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</div>
